import styled from 'styled-components';

export const Container = styled.div`
  text-align: center;
  & > .hefesto-icon svg {
    width: 5rem;
    height: 4.25rem;
    margin-top: 5rem;
  }
`;
